import { Route } from '@angular/router';
import { ModuleRoutes } from '@zayan-erp/shared';
import { ProtectedGuard } from './shared/guards/protected.guard';
import { PublicGuard } from './shared/guards/public.guard';
import { RoleAccessGuard } from './shared/guards/role-access.guard';
import { PageNotFoundComponent } from '../../../../libs/shared/src/lib/components/page-not-found/page-not-found.component';
import { crmResolver } from './shared/resolver/resolver';
import { themeGuard } from './shared/guards/theme.guard';
import { ErpCallbackComponent } from './authentication-module/erp-callback/erp-callback.component';
import { crmSettingsGuard } from './crm-module/crm-role';

export const routes: Route[] = [
  {
    path: 'auth/erp/callback',
    component: ErpCallbackComponent,
    canActivate: [themeGuard('legacy')],
    title: 'Signing in'
  },
  {
    path: '',
    loadChildren: () => import('./authentication-module/auth.routes').then(m => m.AUTH_ROUTES),
    canActivate: [PublicGuard],
    canActivateChild: [themeGuard('legacy')]
  },
  {
    path: 'crm',
    loadChildren: () => import('./crm-module/crm.routes').then(m => m.CrmModuleRoutes),
    canActivate: [ProtectedGuard, RoleAccessGuard],
    canActivateChild: [themeGuard('primeng')],
    data: { module: ModuleRoutes.Crm },
    resolve: { store: crmResolver }
  },
  {
    // OAuth popup callback — runs in a popup opened from an authenticated session,
    // so ProtectedGuard is intentionally omitted. themeGuard applied per SKILL.md §4.
    path: 'auth/google/callback',
    canActivate: [themeGuard('primeng')],
    loadComponent: () =>
      import('./crm-module/settings/crm-oauth-callback/crm-oauth-callback.component').then(
        m => m.CrmOAuthCallbackComponent
      )
  },
  {
    path: 'auth/googlecalendar/callback',
    canActivate: [themeGuard('primeng')],
    loadComponent: () =>
      import('./crm-module/settings/crm-calendar-oauth-callback/crm-calendar-oauth-callback.component').then(
        m => m.CrmCalendarOAuthCallbackComponent
      )
  },
  {
    path: 'auth/outlook/callback',
    canActivate: [themeGuard('primeng')],
    loadComponent: () =>
      import('./crm-module/settings/crm-outlook-oauth-callback/crm-outlook-oauth-callback.component').then(
        m => m.CrmOutlookOAuthCallbackComponent
      )
  },
  {
    // Social channel connect — the aggregator captured the token server-side, so unlike the three
    // above this route redeems no `code`; it only signals the opener to refetch GET /accounts.
    path: 'auth/social/callback',
    canActivate: [themeGuard('primeng')],
    loadComponent: () =>
      import('./crm-module/settings/crm-social-oauth-callback/crm-social-oauth-callback.component').then(
        m => m.CrmSocialOAuthCallbackComponent
      )
  },
  {
    // Manual test panel for the realtime connection: connect/disconnect, echo, and trigger a
    // server-side publish. SuperAdmin only, like the diagnostics endpoint it calls.
    path: 'realtime-diagnostics',
    loadComponent: () => import('@zayan-erp/realtime').then(m => m.RealtimeDiagnosticsComponent),
    canActivate: [ProtectedGuard, crmSettingsGuard],
    canActivateChild: [themeGuard('primeng')]
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [themeGuard('legacy')],
    title: 'Page Not Found',
    data: { type: '404' }
  }
];
